import React, { useState, useEffect } from 'react'
import 'animate.css'
import { Row, Col } from 'antd'
import { Link } from 'react-router-dom'
import CountUp from 'react-countup'

import { Element, Events, scrollSpy } from 'react-scroll'
import { httpClient } from 'core/util/httpClient'
import { home } from 'core/schemas'

import { ReactComponent as Next } from 'assets/images/svg/next.svg'
import titleIcon1 from 'assets/images/png/title-main-1.png'
import logo from 'assets/images/svg/logo.svg'
import homeBG from 'assets/images/jpg/home_bg.jpg'
import homeTopBG from 'assets/images/gif/home-fg.gif'
import homeTopMobile from 'assets/images/gif/SUT_freshmen-mobile-Animate.gif'
import homeTopMobileBG from 'assets/images/png/SUT_freshmen-mobile-bg.png'
import stuView from 'assets/images/png/student_comp-01.png'

import {
  Container,
  TitleHome,
  DetailHome,
  Block,
  BlockNext,
  TextDetail,
  TextName,
  BlockName,
  BgTop,
  BoxImage,
  FixBoxLayout,
  View,
  SubHead,
} from './home.style'

const HomePage = () => {
  const [section, setSection] = useState({ first: {}, secondary: {}, view: 0 })
  const [windowWidth, setWindowWidth] = useState(window.innerWidth)

  useEffect(() => {
    Events.scrollEvent.register('begin', function (to, element) {
      // console.log('begin', arguments)
    })

    Events.scrollEvent.register('end', function (to, element) {
      // console.log('end', arguments)
    })

    scrollSpy.update()

    return () => {
      Events.scrollEvent.remove('begin')
      Events.scrollEvent.remove('end')
    }
  }, [])

  useEffect(() => {
    window.addEventListener('resize', handleResize)
  }, [])

  const handleResize = () => {
    setWindowWidth(window.innerWidth)
  }

  useEffect(() => {
    getDataHome()
  }, [])

  const getDataHome = async () => {
    const response = await httpClient.get(home)

    if (response?.data?.code === 200) {
      const data = response?.data?.data
      const dataSection = data?.section.map((item) => ({
        content: item?.content,
        title: item?.title,
        media: item?.media,
      }))
      setSection({
        first: dataSection[0],
        secondary: dataSection[1],
        view: data?.visitor,
      })
    } else {
      setSection({ first: {}, secondary: {}, view: 0 })
    }
  }

  return (
    <>
      <Container>
        <Block src={windowWidth <= 768 ? homeTopMobileBG : homeBG}>
          <BgTop src={windowWidth < 414 ? homeTopMobile : homeTopBG} />

          <Row className='row-center'>
            <Col span={24}>
              {windowWidth <= 414 && (
                <Link to='/'>
                  <img
                  loading="lazy"
                    onClick={() => window.scrollTo(0, 0)}
                    src={logo}
                    alt='logo header'
                    style={{
                      width: '100%',
                      maxHeight: '100px',
                      padding: '0 10px',
                      marginBottom: '40px',
                    }}
                  />
                </Link>
              )}

              <TitleHome className='animate__animated animate__fadeInDown animate__slow'>
                {section?.first?.title
                  ? section?.first?.title
                  : 'เราจะอยู่เป็นเพื่อนน้อง ๆ ตลอดปีการศึกษา'}
              </TitleHome>
            </Col>
            <Col span={24}>
              <DetailHome className='animate__animated animate__fadeInUp animate__slow'>
                {section?.first?.content
                  ? section?.first?.content
                  : 'เว็บไซต์คู่มือสำหรับน้อง ๆ มทส. ปี 1 ทุกคำตอบของคำถามรวมอยู่ที่นี่'}
              </DetailHome>
            </Col>

            <Col span={24}>
              <BlockNext>
                <BoxImage className='icon-next'>
                  <div
                    style={{
                      width: '100%',
                      display: 'flex',
                      justifyContent: 'center',
                    }}
                  >
                    <Link to='/course-introduction'>
                      <p>อ่านคู่มือ</p>
                    </Link>
                  </div>
                </BoxImage>
              </BlockNext>
            </Col>
          </Row>
        </Block>

        {/* <BlockNext>
          <Link
            activeClass='active'
            to='sut-presidnt'
            spy={true}
            smooth={true}
            duration={500}
            offset={-130}
          >
            <Next className='icon-next' />
          </Link>
        </BlockNext> */}
        {/* <BlockNext>
          <BoxImage className='icon-next'>
            <div
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <Link to='/course-introduction'>
                <p>อ่านคู่มือ</p>
              </Link>
            </div>
          </BoxImage>
        </BlockNext> */}

        {section?.secondary?.link && (
          <Element name='sut-presidnt'>
            <Row align='top' className='row-name'>
              <Col span={10}>
                <BlockName>
                  <img src={titleIcon1} alt='icon title'loading="lazy" />

                  <TextName>
                    {section?.secondary?.title
                      ? section?.secondary?.title
                      : 'สารจากอธิการบดี'}
                  </TextName>
                </BlockName>
              </Col>
              <Col span={14}>
                <TextDetail className='animate__animated animate__zoomInLeft animate__slow'>
                  {section?.secondary?.content
                    ? section?.secondary?.content
                    : 'Lorem Ipsum is simply dummy text of the printing and typesettingindustry. Lorem Ipsum has been the industry’s standard dummytext ever since the 1500s, when an unknown printer took a galleyof type and scrambled it to make a type specimen book. It hassurvived not only five centuries, but also the leap intoelectronic typesetting, remaining essentially unchanged. It waspopularised in the 1960s with the release of Letraset sheetscontaining Lorem Ipsum passages, and more recently with desktoppublishing software like Aldus PageMaker including versions ofLorem Ipsum.'}
                </TextDetail>
              </Col>
            </Row>

            <Row
              style={{
                height: '1078px',
                background: '#72DBF4',
                color: 'black',
                width: '100%',
              }}
            >
              <Col span={24}>vidio</Col>
            </Row>
          </Element>
        )}

        <FixBoxLayout bg='#FFF8E6'>
          <div className='layout-view'>
            <Row className='row-group' style={{ alignItems: 'center' }}>
              <Col span={8}>
                <img
                loading="lazy"
                  src={stuView}
                  style={{ width: '100%', maxWidth: '460px' }}
                  alt='student view'
                />
              </Col>
              <Col span={16}>
                <div style={{ maxwWidth: '450px' }}>
                  <SubHead align='center'>
                    เว็บไซต์คู่มือนี้มีคนเข้ามาดูแล้ว
                  </SubHead>
                  <View>
                    <CountUp
                      start={0}
                      end={section?.view}
                      duration={2}
                      useEasing={true}
                      useGrouping={true}
                      separator=','
                      decimals={0}
                      decimal=','
                    />
                  </View>
                  <SubHead align='center'>ครั้ง</SubHead>
                </div>
              </Col>
            </Row>
          </div>
        </FixBoxLayout>
      </Container>
    </>
  )
}

export default HomePage
